export default __webpack_public_path__ + "static/media/closeresult.1b00331f.svg";